"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Heading, HeroIcon, StepContainer } from "../common.js";
import { ExternalWalletCard, WalletCard, WalletCards } from "../WalletCard/WalletCard.js";
import { useThemeStore } from "../../stores/index.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const LoginDoneStep = ({ onClose }) => {
  var _a;
  const para = useInternalClient();
  const hideWallets = useThemeStore((state) => state.hideWallets);
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 1600);
  }, []);
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    /* @__PURE__ */ jsx(HeroIcon, { icon: "checkCircleFilled" }),
    /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Connected" }),
    !hideWallets && /* @__PURE__ */ jsx(WalletCards, { children: para.isUsingExternalWallet() ? /* @__PURE__ */ jsx(ExternalWalletCard, { address: (_a = Object.values(para.externalWallets || {})[0]) == null ? void 0 : _a.address }) : para.currentWalletIdsArray.map(([id, type]) => {
      return /* @__PURE__ */ jsx(WalletCard, { id, type }, `${id}-${type}`);
    }) })
  ] });
};
export {
  LoginDoneStep
};
